export const ACTIVE = 'Active';
export const WAITING_ACTIVATION = 'WaitingActivation';
export const SCHEDULED_ACTIVATION = 'ScheduledActivation';
